import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "tail.select/css/bootstrap4/tail.select-default.css";
import "./index.scss";
import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import Configuration from "./config";
import AemConfigurations from "./helpers/aemConfigurations";
import store from "./store";
import AemService from "./helpers/aemService";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import AemMenu from "./helpers/aemMenu";
import "./trusted-security-policies";
import json from "./config/env.config.json";
import { AppErrorBoundary } from "./components/AppErrorBoundary/AppErrorBoundary";

const aemService = new AemService();

const init = () => {
  const env = process.env.REACT_APP_ENVIRONMENT || "staging";
  const configurationJson = json[env as keyof typeof json];
  if (!configurationJson) {
    console.log("Configuration not found. Aborting. ");
    throw new Error(
      `Configuration not found. Aborting. Environment:[${process.env.REACT_APP_ENVIRONMENT}]`
    );
  }
  Configuration.set(configurationJson);
  (window as any).dataLayer.push({
    event: "VirtualPageview",
    virtualPageURL: window.location.pathname,
    virtualPageTitle: document.title,
  });

  console.log(
    `gruppocap-areaprivata-fe - environment: ${Configuration.get(
      "REACT_APP_ENVIRONMENT"
    )}`
  );

  aemService
    .getConfigurations()
    .then((aemConfigs) => {
      AemConfigurations.set(aemConfigs);
      aemService.loadMenuObjects().then((menuLinks) => {
        AemMenu.set(menuLinks);

        const container = document.getElementById("root");
        const root = createRoot(container!);

        root.render(
          <Provider store={store}>
            <BrowserRouter basename={"area-riservata"}>
              <AppErrorBoundary>
                <ScrollToTop />
                <App />
              </AppErrorBoundary>
            </BrowserRouter>
          </Provider>
        );
      });
    })
    .catch(() => {
      const container = document.getElementById("root");
      const root = createRoot(container!);

      root.render(
        <Provider store={store}>
          <BrowserRouter basename={"area-riservata"}>
            <App />
          </BrowserRouter>
        </Provider>
      );
      throw new Error("cannot load remote configuration");
    });
};
init();
serviceWorker.unregister();
